<template>
  <div>
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" />
    <!-- 报名成功 -->
    <div class="studyplan-success">
      <div class="box-success">
        <div class="box-data">
          <!-- 计划名称 -->
          <div class="plan-title">恭喜你成功报名「{{ title }}」</div>
          <!-- 分割线 -->
          <div class="plan-line"></div>
          <!-- 参与时间 -->
          <div class="plan-datetext">
            <div>
              学习计划将于
              <span class="plan-date">{{ getPlanDate() }}</span>
              正式开启
            </div>
          </div>
          <!--  -->
          <!-- <div class="plan-codename">
            *请私信班主任关键词【{{ title }}】<br>
            为你安排后续学习！
          </div> -->
          <div class="plan-codename">
            <p>*请复制你的学号发送给班主任为你安排后续学习！</p>
            <div>
              学号【{{ termApplyResult.userSn }}】<span
                :data-clipboard-text="termApplyResult.userSn"
                class="copy"
                id="copyBtn"
                @click="copyStudyID"
                >点击复制</span
              >
            </div>
          </div>
        </div>
        <div class="box-img">
          <div>
            <img
              :src="termApplyResult.adviserErCode || defaultAdviserImg"
              alt=""
            />
          </div>
          <div class="img-label">
            长按上图二维码添加班主任{{
              termApplyResult.adviserName
            }}老师微信<br />
            如已添加过可忽略
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import { defaultAdviserImg } from '@/pages/config'
import { setShareData } from '../options'
import Clipboard from 'clipboard'
import { toast } from '@/utils'
const componentName = 'studyplan-success'
export default {
  name: componentName,
  componentName,
  mixins: [Body],
  data() {
    return {
      title: '友邻学院',
      defaultAdviserImg
    }
  },
  computed: {
    ...mapGetters('goods/vip', [
      'goodsDetail',
      'termInfo',
      // 限购规则
      'limitData'
    ]),
    ...mapGetters('goods-studyplan/plan', ['termApplyResult']),
    termId() {
      return this.termApplyResult.termId
    },
    userSn() {
      console.log('termApplyResult', this.termApplyResult)
      return this.termApplyResult.userSn
    },
    goodsName() {
      const result = this.termApplyResult
      return result.goodsName || result.userPlanName
    }
  },
  created() {
    const { id } = this.$route.params
    this.$store.commit('goods-studyplan/plan/getTermApplyResult', { id })
    // 空页面回跳
    this.$nextTick(() => {
      if (!(this.termId && this.goodsName)) {
        this.$router.replace({ path: `/goods-studyplan` })
      }
    })
  },
  activated() {
    this.title = this.goodsName || '友邻学院'
  },
  methods: {
    // 设置分享地址
    setShareData,
    getPlanDate() {
      const result = this.termApplyResult
      const date = (result.userPlanStartDate || '00000000').toString()
      const y = parseInt(date.substr(0, 4))
      const m = parseInt(date.substr(4, 2))
      const d = parseInt(date.substr(6, 2))
      return `${y}年${m}月${d}日`
      // return this.$moment(date).format('YYYY-MM-DD')
    },
    copyStudyID() {
      console.log('走进复制函数')
      const clipboard = new Clipboard('#copyBtn')
      clipboard.on('success', function(e) {
        toast('复制成功')
        e.clearSelection()
      })
      clipboard.on('error', function(e) {
        toast('复制失败 请重新复制')
      })
    }
  }
}
</script>

<style lang="scss">
.body-studyplan-success {
  background-color: #212b2eff;
}
</style>
<style lang="less" scoped>
.studyplan-success {
  background: url('../../../../images/goods-studyplan/planorder_bg.png')
    no-repeat;
  background-size: 100% 100%;
  padding-top: 1.66rem;
  .box-success {
    margin: 0 0.36rem;
    border-radius: 0.09rem;
    text-align: center;
    .box-data {
      background: url('../../../../images/goods-studyplan/planorder_success_bg.png')
        no-repeat;
      background-size: 100% 100%;
      height: 4.98rem;
      .plan-title {
        padding-top: 0.56rem;
        font-size: 0.34rem;
        color: #683100;
        font-weight: bold;
        line-height: 0.47rem;
      }
      .plan-line {
        border-top: 1px dashed #683100;
        margin: 0.37rem 0.87rem 0.37rem 0.87rem;
      }
      .plan-codename {
        font-size: 0.28rem;
        line-height: 0.39rem;
        color: #683100;
        font-weight: bold;
        margin-bottom: 0.28rem;
        margin-top: 0.24rem;
        p {
          margin-bottom: 0.1rem;
        }
        div {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .copy {
          background: #683100;
          width: 1.28rem;
          height: 0.38rem;
          text-align: center;
          line-height: 0.38rem;
          color: #ffffff;
          border-radius: 0.19rem;
          font-size: 0.24rem;
          display: block;
        }
      }
      .plan-datetext {
        font-size: 0.26rem;
        color: #683100;
        line-height: 0.42rem;
        font-weight: bold;
        .plan-date {
          background: #683100;
          color: #ffffff;
          border-radius: 16px;
          padding: 0 0.15rem;
          display: inline-block;
        }
      }
    }
    .box-img {
      img {
        width: 2.61rem;
        height: 2.61rem;
        margin-bottom: 0.29rem;
      }
      .img-label {
        font-size: 0.22rem;
        color: #683100;
        line-height: 0.31rem;
        font-weight: bold;
      }
    }
    background: linear-gradient(90deg, #e4d6c9 0%, #ddb999 100%);
    height: 9.25rem;
  }
}
</style>
